import { Injectable } from '@angular/core';
import { ContentFilterValues } from '../../../../core/models/i-content-filter-values';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  public getContentFilters(id: string): ContentFilterValues {
    let jsonString: string = localStorage.getItem(`content-filter-${id}`);

    let storedValues: ContentFilterValues = JSON.parse(jsonString);

    return storedValues;
  }

  public setContentFilters(
    filters: ContentFilterValues,
    id: string,
  ): ContentFilterValues {
    localStorage.setItem(`content-filter-${id}`, JSON.stringify(filters));

    return this.getContentFilters(id);
  }

  public defaultContentFilters(id: string, pageSize): ContentFilterValues {
    let defaultValues: ContentFilterValues = new ContentFilterValues(
      [],
      [],
      [],
      [],
      [],
      5,
      pageSize,
    );
    this.setContentFilters(defaultValues, id);

    return this.getContentFilters(id);
  }

  public getActiveDashboard() {
    return localStorage.getItem('active-dashboard');
  }

  public setActiveDashboard(activeTab: string) {
    localStorage.setItem('active-dashboard', activeTab);
  }
}
